import { useNavigate } from "react-router-dom";
import DetailRow from "../DetailRow";
import HeadingDialog from "../HeadingDialog";
import { timeStampToDateAndTime } from "../../../../functions/dateTime/timeStampToDateAndTime";
import Modal from "../../../portal/Modal";
import GradientButton from "../../buttonUI/GradientButton";
import ExpensesList from "./ExpensesList";
import successIcon from "../../../../assets/icons/successIcon.svg";

export default function SheetView({
  closeDialog,
  viewDetails,
  successView,
  isLoaded,
}) {
  const navigate = useNavigate();
  return (
    <Modal
      onClose={successView ? undefined : closeDialog}
      modalWidth="view-dialog-content max-w-4xl"
      closeIcon={!successView}
    >
      {!successView && (
        <HeadingDialog heading="Uploaded Expense Sheet Details" />
      )}
      <div className="overflow-auto">
        {successView && (
          <>
            <img
              src={successIcon}
              alt="messageIcon"
              className="mx-auto mb-1 w-9"
            />

            <p className="view-success-msg-d">Successfully Sheet Uploaded!</p>
          </>
        )}
        {isLoaded ? (
          <>
            {!successView && (
              <div className="view-dialog-content-wrap">
                <DetailRow
                  title="Uploaded By"
                  value={viewDetails.createdBy.fullName}
                />
                <DetailRow
                  title="Uploaded At"
                  value={timeStampToDateAndTime(viewDetails.createdAt)}
                />
              </div>
            )}
            <ExpensesList expenseList={viewDetails.expenses} />
          </>
        ) : (
          <p className="text-center">Details Loading...</p>
        )}
      </div>
      {successView && (
        <div className="mt-5 pt-3 text-center">
          <GradientButton
            btnText="Ok"
            width="w-28"
            onClick={() => navigate("/sheet/uploaded-all")}
          />
        </div>
      )}
    </Modal>
  );
}
